var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.efficiencyGrid)?_c('div',{staticClass:"col-12"},[_c('line-chart',{attrs:{"datasets":_vm.lineChartDataset,"show-legend":false,"animation-duration":0,"height":null,"width":null,"y-axes-begin-at-zero":true}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27eaabfc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/components/DataEfficiency.vue
// module id = 1399
// module chunks = 1